import { Color, DisplayMode, Engine, FadeInOut, Logger, LogLevel } from 'excalibur';
import { TutorialLevel } from './world/tutorialLevel';
import { DummyLevel } from './world/dummyLevel';
import { initGUI } from './gui';
import { configStore } from './store';
import './i18n';
import { loader, Music, SFX, TypingSFX } from './world/resources';
import { AudioManager } from '@game-libs/audio-manager';
import { initAllListeners } from './listeners';
import { GUIActions } from './types/game-types';
import { EventsManager } from '@game-libs/events-manager';
import { GameEvents } from '@game-libs/models';
import { GlobalGameStore } from '@game-libs/global-game-store';
import './init';
import { ensureGameStateBootstrapped } from './store/init-state';


if (import.meta.env.VITE_GAME_ISDESKTOP === 'true') {

  // const greenworks = require("./greenworks.js").default;


  // if (!greenworks.init()) {
  //   console.error("Steam failed to initialize");
  // } else {

  //   console.log('Steam API initialized successfully.');

  //   console.log('Cloud enabled: ' + greenworks.isCloudEnabled());
  //   console.log('Cloud enabled for user: ' + greenworks.isCloudEnabledForUser());

  //   greenworks.on('game-overlay-activated', function (is_active: boolean) { console.log('overlay active: ' + is_active); });
  //   greenworks.on('steam-servers-connected', function () { console.log('connected'); });
  //   greenworks.on('steam-servers-disconnected', function () { console.log('disconnected'); });
  //   greenworks.on('steam-server-connect-failure', function () { console.log('connected failure'); });
  //   greenworks.on('steam-shutdown', function () { console.log('shutdown'); });

  //   // greenworks.activateGameOverlay("Friends");
  //   console.log(greenworks);

  //   console.log("App ID:", greenworks.getAppId());

  //   // greenworks.saveTextToFile('test_file.txt', 'test_content',
  //   //   function () { console.log('Save text to file successfully'); },
  //   //   function (err: Error) { console.log('Failed on saving text to file'); });

  //   // greenworks.readTextFromFile('test_file.txt', function (message: string) {
  //   //   console.log('Read text from file successfully.');
  //   // }, function (err: Error) {
  //   //   console.log('Failed on reading text from file');
  //   // });

  //   greenworks.getCloudQuota(
  //     function (quota: number, used: number) { console.log('Getting cloud quota successfully: ' + used + ' of ' + quota) },
  //     function (err: Error) { console.log('Failed on getting cloud quota.') });

  //   // // The ACH_WIN_ONE_GAME achievement is available for the sample (id:480) game
  //   // greenworks.activateAchievement('ACH_WIN_ONE_GAME',
  //   //   function () { console.log('Activating achievement successfully'); },
  //   //   function (err: Error) { console.log('Failed on activating achievement.'); });

  //   // window.addEventListener('keydown', function (e) {
  //   //   if (e.key === 'h' || e.key === 'H') {
  //   //     console.log('H key pressed');

  //   //     greenworks.activateAchievement('TEST_ACH_1',
  //   //       function () { console.log('Activating achievement successfully'); },
  //   //       function (err: Error) { console.log('Failed on activating achievement.'); });
  //   //   }
  //   // });




  //   greenworks.getNumberOfPlayers(
  //     function (a: number) { console.log("Number of players " + a) },
  //     function (err: Error) { console.log('Failed on getting number of players'); });

  //   console.log("Numer of friends: " +
  //     greenworks.getFriendCount(greenworks.FriendFlags.Immediate));
  //   var friends = greenworks.getFriends(greenworks.FriendFlags.Immediate);
  //   var friends_names = [];
  //   for (var i = 0; i < friends.length; ++i)
  //     friends_names.push(friends[i].getPersonaName());
  //   console.log("Friends: [" + friends_names.join(',') + "]");
  // }
}

const { emit, on } = EventsManager();

loader.backgroundColor = '#120e23';
loader.logo = './images/game_loader_big.png';
loader.logoWidth = 700;//429;
loader.logoHeight = 584;//241;

const game = new Engine({
  // width: 1920,
  // height: 1080,
  displayMode: DisplayMode.FitContainerAndFill,

  resolution: {
    width: 2000,
    height: 1000,
  },
  canvasElementId: 'game',
  suppressConsoleBootMessage: true,
  suppressPlayButton: import.meta.env.VITE_GAME_ISDESKTOP === 'true',
  backgroundColor: Color.fromHex('#120e23'),
  // backgroundColor: Color.Green,
  pixelArt: true,
  scenes: {
    tutorial: {
      scene: TutorialLevel,
      transitions: {
        in: new FadeInOut({ duration: 500, direction: 'in', color: Color.fromHex('#120e23') }),
        out: new FadeInOut({ duration: 500, direction: 'out', color: Color.fromHex('#120e23') }),
      },
    },
    dummy: {
      scene: DummyLevel,
      transitions: {
        in: new FadeInOut({ duration: 500, direction: 'in', color: Color.fromHex('#120e23') }),
        out: new FadeInOut({ duration: 500, direction: 'out', color: Color.fromHex('#120e23') }),
      },
    },
  },
});

const { state, settings, actions } = GlobalGameStore();

// Wait for state to load before determining which level to start
actions.loadState().then(async () => {
  // Apply font preference from saved state
  const { useAlternativeFont, largerTextSize } = settings.value;
  if (!useAlternativeFont) {
    document.body.style.setProperty('--font-primary', 'pixelAe');
    (document.documentElement as HTMLElement).style.setProperty('--font-multiplier', '1.2');
  } else {
    document.body.style.setProperty('--font-primary', 'everyday_slight');
    (document.documentElement as HTMLElement).style.setProperty('--font-multiplier', '1');
  }
  (document.documentElement as HTMLElement).style.setProperty('--larger-text-size', largerTextSize ? '1' : '0');

  // Bootstrap Zustand + version mismatch reset before picking the Excalibur scene.
  await ensureGameStateBootstrapped();

  // Fixes bug where gemshell returns a signal instead of a string when the save state is not saved yet
  const loadedLevelToLoad = state.currentLevel.value;
  let levelToLoad: 'tutorial' | 'dummy' = 'tutorial';

  if (typeof loadedLevelToLoad === 'string' && loadedLevelToLoad.length > 0) {
    levelToLoad = loadedLevelToLoad as 'tutorial' | 'dummy';
  }

  game
    .start(levelToLoad, {
      loader,
    })
    .then(() => {
      const logger = Logger.getInstance();

      // if (import.meta.env.VITE_IS_PROD === 'true') {
      logger.defaultLevel = LogLevel.Fatal;
      // }


      const { playMusicTrack } = AudioManager({ SFX, TypingSFX, Music });
      configStore();
      initGUI();
      // Configure modules
      playMusicTrack('game_music');

      initAllListeners(game);

      on(GameEvents.CHANGE_SCENE, ({ levelName }: { levelName: string }) => {
        actions.setCurrentLevel(levelName);
        game.goToScene(levelName as 'tutorial' | 'dummy');
      });

      //@ts-expect-error Using private method
      game.screen._resizeHandler();
    });
});

// game.showDebug(true);

document.addEventListener('mouseover', (event) => {
  const target = (event.target as HTMLElement | null)?.closest('.hover-target') as HTMLElement | null;

  if (!target) return;

  const related = event.relatedTarget as HTMLElement | null;

  // If coming from inside the same element, ignore
  if (related && target.contains(related)) return;

  emit(GUIActions.HOVER_ITEM);

  // @ts-ignore - Steam SDK global
  if (typeof steam !== 'undefined') {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    // Steam features available
    // @ts-ignore - Steam SDK
    // @ts-ignore - Steam SDK
    (steam as any).activateOverlay('Friends');
  }
});

// console.console.log('window.visualViewport', window.visualViewport);

// window.visualViewport?.addEventListener('resize', () => {
//   console.console.log('window.visualViewport.resize', window.visualViewport);
// });

// window.addEventListener('resize', () => {
//   console.console.log('window.resize DPR', window.devicePixelRatio);
// });
// console.console.log('window.resize DPR', window.devicePixelRatio);

const dpr = window.devicePixelRatio || 1;
document.documentElement.style.setProperty('--init-game-scale', (1 / dpr).toString());
